import { createReducer, on } from '@ngrx/store';
import { setImmigrationDetails, clearImmigrationDetails } from './immigrationDetails.action';
import { initialImmigrationDetailsState } from './immigrationDetails.state';
export const ImmigrationDetailsReducer = createReducer(
  initialImmigrationDetailsState,
  on(setImmigrationDetails, (state, { immigrationDetails }) => ({ ...state, immigrationDetails : immigrationDetails })),
  on(clearImmigrationDetails, state => ({ ...state, immigrationDetails : null }))
);